<template>
  <v-layout row wrap>
    <v-flex xs12>
      <crud
        :resource="
          isClientAdmin()
            ? 'departments?clientId=' + getClientId()
            : 'departments'
        "
        :manager="manager"
      ></crud>
    </v-flex>
  </v-layout>
</template>

<script>
import Crud from './Crud'
import CrudBase from './CrudBase.vue'

export default {
  name: 'Departments',
  extends: CrudBase,
  components: { Crud },
  methods: {
    initialize() {
      // let that = this
    },
    getClientId() {
      return this.$auth.user().client.id
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Departments.vue